import * as ambassadorWixAccessibilityV1AccessibilityScan from './accessibility-v1-accessibility-scan-accessibility-scans.http.js';
import * as ambassadorWixAccessibilityV1AccessibilityScanTypes from './accessibility-v1-accessibility-scan-accessibility-scans.types.js';
import * as ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes from './accessibility-v1-accessibility-scan-accessibility-scans.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function runAccessibilityScan(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.RunAccessibilityScanRequest,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.RunAccessibilityScanRequest,
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.RunAccessibilityScanResponse,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.RunAccessibilityScanResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAccessibilityV1AccessibilityScan.runAccessibilityScan(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accessibility-scans/run',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAccessibilityScanPageCollections(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.ListAccessibilityScanPageCollectionsRequest,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.ListAccessibilityScanPageCollectionsRequest,
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.ListAccessibilityScanPageCollectionsResponse,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.ListAccessibilityScanPageCollectionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAccessibilityV1AccessibilityScan.listAccessibilityScanPageCollections(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accessibility-scans/page-collections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAccessibilityScanPageSummaries(): __PublicMethodMetaInfo<
  'GET',
  { accessibilityScanId: string },
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.ListAccessibilityScanPageSummariesRequest,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.ListAccessibilityScanPageSummariesRequest,
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.ListAccessibilityScanPageSummariesResponse,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.ListAccessibilityScanPageSummariesResponse
> {
  const payload = { accessibilityScanId: ':accessibilityScanId' } as any;

  const getRequestOptions =
    ambassadorWixAccessibilityV1AccessibilityScan.listAccessibilityScanPageSummaries(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accessibility-scans/{accessibilityScanId}/page-summaries',
    pathParams: { accessibilityScanId: 'accessibilityScanId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLatestAccessibilityScan(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.GetLatestAccessibilityScanRequest,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.GetLatestAccessibilityScanRequest,
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.GetLatestAccessibilityScanResponse,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.GetLatestAccessibilityScanResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAccessibilityV1AccessibilityScan.getLatestAccessibilityScan(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accessibility-scans/latest',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAccessibilityScan(): __PublicMethodMetaInfo<
  'GET',
  { accessibilityScanId: string },
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.GetAccessibilityScanRequest,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.GetAccessibilityScanRequest,
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.GetAccessibilityScanResponse,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.GetAccessibilityScanResponse
> {
  const payload = { accessibilityScanId: ':accessibilityScanId' } as any;

  const getRequestOptions =
    ambassadorWixAccessibilityV1AccessibilityScan.getAccessibilityScan(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accessibility-scans/{accessibilityScanId}',
    pathParams: { accessibilityScanId: 'accessibilityScanId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAccessibilityScanFindings(): __PublicMethodMetaInfo<
  'GET',
  { accessibilityScanId: string },
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.ListAccessibilityScanFindingsRequest,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.ListAccessibilityScanFindingsRequest,
  ambassadorWixAccessibilityV1AccessibilityScanUniversalTypes.ListAccessibilityScanFindingsResponse,
  ambassadorWixAccessibilityV1AccessibilityScanTypes.ListAccessibilityScanFindingsResponse
> {
  const payload = { accessibilityScanId: ':accessibilityScanId' } as any;

  const getRequestOptions =
    ambassadorWixAccessibilityV1AccessibilityScan.listAccessibilityScanFindings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accessibility-scans/{accessibilityScanId}/findings',
    pathParams: { accessibilityScanId: 'accessibilityScanId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AccessibilityScan as AccessibilityScanOriginal,
  AccessibilityScanTarget as AccessibilityScanTargetOriginal,
  AccessibilityScanTargetTargetOneOf as AccessibilityScanTargetTargetOneOfOriginal,
  TargetType as TargetTypeOriginal,
  TargetTypeWithLiterals as TargetTypeWithLiteralsOriginal,
  AccessibilityScanScope as AccessibilityScanScopeOriginal,
  AccessibilityScanScopeWithLiterals as AccessibilityScanScopeWithLiteralsOriginal,
  PageScanTarget as PageScanTargetOriginal,
  PageScanTargetIdentifierOneOf as PageScanTargetIdentifierOneOfOriginal,
  PageCollectionScanTarget as PageCollectionScanTargetOriginal,
  AccessibilityScanStatus as AccessibilityScanStatusOriginal,
  AccessibilityScanStatusWithLiterals as AccessibilityScanStatusWithLiteralsOriginal,
  AccessibilityScanProgress as AccessibilityScanProgressOriginal,
  AccessibilityScanSummary as AccessibilityScanSummaryOriginal,
  AccessibilitySeverityCount as AccessibilitySeverityCountOriginal,
  AccessibilitySeverity as AccessibilitySeverityOriginal,
  AccessibilitySeverityWithLiterals as AccessibilitySeverityWithLiteralsOriginal,
  AccessibilityFindingCategoryCount as AccessibilityFindingCategoryCountOriginal,
  AccessibilityFindingCategory as AccessibilityFindingCategoryOriginal,
  AccessibilityFindingCategoryWithLiterals as AccessibilityFindingCategoryWithLiteralsOriginal,
  AccessibilityScanCoverage as AccessibilityScanCoverageOriginal,
  AccessibilityScanFailure as AccessibilityScanFailureOriginal,
  AccessibilityScanFailureCode as AccessibilityScanFailureCodeOriginal,
  AccessibilityScanFailureCodeWithLiterals as AccessibilityScanFailureCodeWithLiteralsOriginal,
  RunAccessibilityScanRequest as RunAccessibilityScanRequestOriginal,
  RunAccessibilityScanResponse as RunAccessibilityScanResponseOriginal,
  ExistingAccessibilityScanError as ExistingAccessibilityScanErrorOriginal,
  ScanSizeLimitExceededError as ScanSizeLimitExceededErrorOriginal,
  AccessibilityScanStateUnknownError as AccessibilityScanStateUnknownErrorOriginal,
  ListAccessibilityScanPageCollectionsRequest as ListAccessibilityScanPageCollectionsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListAccessibilityScanPageCollectionsResponse as ListAccessibilityScanPageCollectionsResponseOriginal,
  AccessibilityScanPageCollection as AccessibilityScanPageCollectionOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ListAccessibilityScanPageSummariesRequest as ListAccessibilityScanPageSummariesRequestOriginal,
  ListAccessibilityScanPageSummariesResponse as ListAccessibilityScanPageSummariesResponseOriginal,
  AccessibilityScanPageSummary as AccessibilityScanPageSummaryOriginal,
  AccessibilityPageReference as AccessibilityPageReferenceOriginal,
  AccessibilityPageCollectionReference as AccessibilityPageCollectionReferenceOriginal,
  AccessibilityPageScanStatus as AccessibilityPageScanStatusOriginal,
  AccessibilityPageScanStatusWithLiterals as AccessibilityPageScanStatusWithLiteralsOriginal,
  GetLatestAccessibilityScanRequest as GetLatestAccessibilityScanRequestOriginal,
  GetLatestAccessibilityScanResponse as GetLatestAccessibilityScanResponseOriginal,
  GetAccessibilityScanRequest as GetAccessibilityScanRequestOriginal,
  GetAccessibilityScanResponse as GetAccessibilityScanResponseOriginal,
  ListAccessibilityScanFindingsRequest as ListAccessibilityScanFindingsRequestOriginal,
  AccessibilityFindingFilter as AccessibilityFindingFilterOriginal,
  ListAccessibilityScanFindingsResponse as ListAccessibilityScanFindingsResponseOriginal,
  AccessibilityFinding as AccessibilityFindingOriginal,
  AccessibilityElementReference as AccessibilityElementReferenceOriginal,
  WcagCriterion as WcagCriterionOriginal,
  WcagLevel as WcagLevelOriginal,
  WcagLevelWithLiterals as WcagLevelWithLiteralsOriginal,
  AccessibilityFixGuidance as AccessibilityFixGuidanceOriginal,
  AccessibilityFixCategory as AccessibilityFixCategoryOriginal,
  AccessibilityFixCategoryWithLiterals as AccessibilityFixCategoryWithLiteralsOriginal,
  RunAccessibilityScanApplicationErrors as RunAccessibilityScanApplicationErrorsOriginal,
  ListAccessibilityScanPageSummariesApplicationErrors as ListAccessibilityScanPageSummariesApplicationErrorsOriginal,
  GetLatestAccessibilityScanApplicationErrors as GetLatestAccessibilityScanApplicationErrorsOriginal,
  GetAccessibilityScanApplicationErrors as GetAccessibilityScanApplicationErrorsOriginal,
  ListAccessibilityScanFindingsApplicationErrors as ListAccessibilityScanFindingsApplicationErrorsOriginal,
} from './accessibility-v1-accessibility-scan-accessibility-scans.types.js';
